import axios from "axios";
import React, { useRef, useState, useEffect } from "react";
import { FxmsData } from "../datas/FxData";
import Link from "@mui/material/Link";

/*
ㄱ. 기능
1. 데이터그리드 첨부파일 조인조회 - 링크처리
2. 파일 다운로드

ㄴ. 형식 (file형식과 동일하게 구성) - 어떤 페이지건 아래의 형식으로 생성하되 ATTR_VAL_LIST의 fileKey는 테이블의 pk값, flieUrl은 페이지구분값을 넣으면 된다.
ui-4-1-list	grid	filelink	120	파일링크	filelink	facNo	{"type":"filelink", "fileKey" : "facNo", "fileUrl" : "4_1"}			N	Y		300		Y		N	-1	1	20221014104636	1	20221014104636
*/
export const FxFileLink = (props) => {
  console.log("fxFileLink", props);

  const [orgNm, setOrgNm] = useState(props.orgNm);
  const [fileId, setFileId] = useState(props.fileId);

    /*
    //1. 그리드의 row pk값으로 파일명 가져오기 -> 소스 수정없이 디비의 속성값으로만 적용이 가능하나 지속적인 렌더러 문제 발생
    //2. 코드값처럼 소스 초기에 파일명을 전부 가져오기 -> 위의 렌더러 문제는 없어지나 새로 추가되는 파일명은 가져오지 못함
    //3. 쿼리 조인 처리후 가져오기로 변경 -> 백엔드 쿼리의 수정은 필요하다.
  const [orgNm, setOrgNm] = useState("");
  const [fileId, setFileId] = useState("");

  const [fileUrl, setFileUrl] = useState(props.fileUrl);
  const [fileKey, setFileKey] = useState(props.fileKey);
  useEffect(() => {
    console.log("fileprop", props);
    getFileInfo();
  }, [fileUrl, fileKey]);
  //2. 수정필요 - 이부분은 추후 코드처럼 맵으로 바꿔서 처리
  //데이터 그리드에서 파일링크 컴포넌트가 있으면 파일명+id를 가져옴
  async function getFileInfo() {
    axios
      .post(
        "/api/open/file",
        {
          fileUrl: fileUrl,
          fileKey: fileKey,
        },
        FxmsData.getHeader()
      )
      .then(function (res) {
        setOrgNm(res.data.orgNm);
        setFileId(res.data.fileId);
      })
      .catch(function (error) {
        return "";
      })
      .finally(function () {});
  }
*/
  // 다운로드 파일 이름을 추출하는 함수
  const extractDownloadFilename = (response) => {
    const disposition = response.headers["content-disposition"];
    const fileName = decodeURI(
      disposition
        .match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1]
        .replace(/['"]/g, "")
    );
    return fileName;
  };

  const onDownload = () => {
    axios({
      url: "/api/open/download/" + fileId, // 파일 다운로드 요청 URL
      method: "GET", // 혹은 'POST'
      responseType: "blob", // 응답 데이터 타입 정의
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    }).then((response) => {
      // 다운로드(서버에서 전달 받은 데이터) 받은 바이너리 데이터를 blob으로 변환합니다.
      const blob = new Blob([response.data]);
      // 특정 타입을 정의해야 경우에는 옵션을 사용해 MIME 유형을 정의 할 수 있습니다.
      // const blob = new Blob([this.content], {type: 'text/plain'})

      // blob을 사용해 객체 URL을 생성합니다.
      const fileObjectUrl = window.URL.createObjectURL(blob);

      // blob 객체 URL을 설정할 링크를 만듭니다.
      const link = document.createElement("a");
      link.href = fileObjectUrl;
      link.style.display = "none";

      // 다운로드 파일 이름을 지정 할 수 있습니다.
      // 일반적으로 서버에서 전달해준 파일 이름은 응답 Header의 Content-Disposition에 설정됩니다.
      link.download = extractDownloadFilename(response);

      // 다운로드 파일의 이름은 직접 지정 할 수 있습니다.
      // link.download = "sample-file.xlsx";

      // 링크를 body에 추가하고 강제로 click 이벤트를 발생시켜 파일 다운로드를 실행시킵니다.
      document.body.appendChild(link);
      link.click();
      link.remove();

      // 다운로드가 끝난 리소스(객체 URL)를 해제합니다.
      window.URL.revokeObjectURL(fileObjectUrl);
    });
  };

  return (
    <Link component="button" variant="body2" onClick={onDownload}>
      {orgNm}
    </Link>
  );
};
